import React from "react";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { T, CARD_SHADOW } from "../constants";
import { cx } from "../styles";

/* ---------- Panel (signature Drivo card) ---------- */

const usePanel = makeStyles({
  panel: {
    background: T.elevated,
    border: `1px solid ${T.borderSoft}`,
    borderRadius: 14,
    boxShadow: CARD_SHADOW,
    overflow: "hidden",
  },
});

export default function Panel({ children, className, ...rest }) {
  const c = usePanel();
  return (
    <Paper elevation={0} className={cx(c.panel, className)} {...rest}>
      {children}
    </Paper>
  );
}
